import { render, staticRenderFns } from "./tableBenefit.vue?vue&type=template&id=2f993fd5&"
import script from "./tableBenefit.js?vue&type=script&lang=js&"
export * from "./tableBenefit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports